export default (state, query) => {
  const result = { query };

  if (query && typeof query.debug != 'undefined') {
    result.debug = query.debug == 'true' ? true : false;
  }

  return result;
};
